// @flow
import { connect } from 'react-redux';

import NotificationContainer from './NotificationContainer';

const mapStateToProps = ({ ccMode: { notifications } }) => ({
  notifications,
});

export default connect(mapStateToProps)(NotificationContainer);
